import { c as _c } from "react/compiler-runtime";
import { DeliveryType } from '@libs/core';
import { useAutoshipDecisions } from './useAutoshipDecisions';
import { useCart } from './useCart';

/**
 * Hook to check if SDD + Autoship scenario should show shipping address section and banner
 */
export function useIsSddWithAutoship() {
  const $ = _c(2);
  const {
    cart
  } = useCart();
  const {
    isAutoshipCrawl
  } = useAutoshipDecisions();
  let t0;
  if ($[0] !== cart?.fulfillmentGroups) {
    t0 = cart?.fulfillmentGroups?.some(_temp2);
    $[0] = cart?.fulfillmentGroups;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasSddWithAutoship = t0;
  return isAutoshipCrawl && hasSddWithAutoship;
}
function _temp2(group) {
  return group.fulfillmentMethod.toLowerCase() === DeliveryType.SDD && group.items?.some(_temp);
}
function _temp(item) {
  return item.autoshipFrequency && item.autoshipFrequencyUnitOfMeasure;
}